/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsCollection = {
  init: function($section) {

    // Add settings from schema to current object
    Shopify.theme.jsCollection = $.extend(this, Shopify.theme.getSectionData($section));

    // function to check if browser is IE
    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

    // Ensure product media libraries are present
    if (!isIE11) {
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
        }
      ],)
    }

    if (this.enable_sorting == true) {
      $('#sort-by').val($('#sort-by').data('default-sort'));
    }

    if (this.enable_filter == true || this.enable_sorting == true) {
      $('#tag_filter, #sort-by').on('change', function() {
        Shopify.theme.jsCollection.filterURL();
      });
    }

    if ($('[data-option-filter]').length) {
      // Show enabled filter tags based on selected checkboxes
      $('[data-tag-filter-checkbox]:checked').each(function(){
        Shopify.theme.jsCollection.multiTagFilter.showSelectedFilter($(this));
      })
    }

    // If breadcrumbs enabled and basic pagination is set, call breadcrumbs object
    if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
      Shopify.theme.breadcrumbs.init(this.number_of_pages);
    }

    /* Collection sidebar filter */
    $('body').on('click', '[data-option-filter]', function(e) {
      e.preventDefault();

      $(this).find('input').prop('checked', true);

      Shopify.theme.jsCollection.multiTagFilter.init($(this));
      Shopify.theme.scrollToTop($('.collection__content'));
    });

    $('body').on('click', '[data-clear-filter]', function () {
      const $el = $(this).siblings('[data-option-filter]');
      const $productTagFilter = $('#tag_filter');

      $productTagFilter.find('option:eq(0)').prop('selected', true);
      Shopify.theme.jsCollection.multiTagFilter.clearSelectedFilter($el);
      Shopify.theme.scrollToTop($('.collection__content'));

    });
  },
  filterURL: function() {

    var selectedOptions = [],
        query = '',
        currentTags = '',
        siteUrl = 'https://' + $.url('hostname');

    // check if language has been translated. Length equals one when default language (eg: '/') and greater than 1 when language is translated (eg: '/fr')
    if (Shopify.routes.root_url.length > 1) {
      var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
      var url2 = $.url('2') ? $.url('2') + '/' : '';
      var url3 = $.url('3') ? $.url('3') + '/' : '';
      var path = url1 + url2 + url3;
    } else {
      var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
      var url2 = $.url('2') ? $.url('2') + '/' : '';
      var path = url1 + url2;
    }

    //Handle dropdowns if they exist
    if ($('#sort-by').length){
      query = $('#sort-by').val();
    } else {
      query = url('?sort_by');
    }

    if ($('#tag_filter').length){

      if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()){
        var urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

        if (urlTag != 'all'){
          if ($.inArray( urlTag, selectedOptions ) > -1){
            //Do nothing
          } else {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    }

    //Add all checkbox values to array
    $('[data-option-filter] input:checked').each(function () {
      selectedOptions.push($(this).val());
    });

    selectedOptions = $.makeArray(selectedOptions);

    //Loop through tags to create string to update page url
    $.each(selectedOptions, function(i, value){

      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
      } else {
        currentTags += selectedOptions[i];
      }

    });

    Shopify.theme.queryParameters.sort_by = query;
    query = '?' + $.param(Shopify.theme.queryParameters);

    this.processUrl(path, currentTags, query);
  },
  processUrl: function (path, tags, query) {
    console.log('path:');
    console.log(path);
    console.log('tags:');
    console.log(tags);
    console.log('query:');
    console.log(query);
    console.log('tag_filter:');
    console.log($('#tag_filter').val());
    console.log('sort-by:');
    console.log($('#sort-by').val());
    var query = query.replace(/\page=(\w+)&/, ''),
      urlString = '';

    urlString = path + tags + query;

    this.updateView(urlString);

  },
  updateView: function(filterURL) {
    console.log('sort-by:');
    console.log($('#sort-by').val());
    console.log('updateView filterURL');
    console.log(filterURL);
    var custom_brand_name = $('.custom_brand_name').val();
    var brand_new_arrivals_links = $('.brand_new_arrivals_links').val();
    var brand_has_new_arrivals = false;
    if( $('#sort-by').val() == 'created-descending' && custom_brand_name != '' ){
      $('.brand_new_arrivals_links_old').val(filterURL);
      // filterURL = brand_new_arrivals_links;
      brand_has_new_arrivals = true;
    }
    if( brand_has_new_arrivals ){
      var arr = [];
        $.ajax({
          type: 'GET',
          url: brand_new_arrivals_links,
          beforeSend: function() {
            // $('.collection-matrix').addClass('fadeOut animated loading-in-progress');
            // $('.collection-matrix__wrapper .collection__loading-icon').fadeIn();
          },
          success: function(data) {
          },
          error: function(x, t, m) {
            console.log(x);
            console.log(t);
            console.log(m);
            location.replace(location.protocol + '//' + location.host + filterURL);

          },
          dataType: "html"
        }).then(function(data){
          console.log('custom brand new arrivals collections');
          console.log(data);
          if( $('#sort-by').val() == 'created-descending' && custom_brand_name != '' ){
            console.log('collection-matrix__wrapper');
            console.log($(data).find('.collection-matrix__wrapper .product-item-product-card'));
            $(data).find('.collection-matrix__wrapper .product-item-product-card').each(function(index, element) {
              console.log($(element).data('id'));
              var product_id = parseInt($(element).data('id'));
              if( arr[product_id] != '' ){
                arr[product_id] = $(element);
              }
            });
            console.log('PRODUCT ON NEW ARRIVAL COLLECTION');
            console.log('arr');
            console.log(arr);
            var brand_products_old_url = $('.brand_new_arrivals_links_old');
            // Get Products From collection with created-descending
            $.ajax({
              type: 'GET',
              url: filterURL,
              beforeSend: function() {
                $('.collection-matrix').addClass('fadeOut animated loading-in-progress');
                $('.collection-matrix__wrapper .collection__loading-icon').fadeIn();
              },
              success: function(data) {
              },
              error: function(x, t, m) {
                console.log(x);
                console.log(t);
                console.log(m);
                location.replace(location.protocol + '//' + location.host + filterURL);

              },
              dataType: "html"
            }).then(function(data){
              console.log('Old Collections');
              console.log(data);
              $(data).find('.collection-matrix__wrapper .product-item-product-card').each(function(index, element) {
                console.log($(element).data('id'));
                var product_id = parseInt($(element).data('id'));
                // if( arr[product_id] != '' ){
                  arr[product_id] = $(element);
                // }
              });
              console.log('PRODUCTS ON OLD + NEW ARRIVAL COLLECTION');
              console.log('arr');
              console.log(arr);

              if( $('#sort-by').val() == 'new-arrival-descending' ){
                var tags_for_new_arrival = $('.new_arrival_tags').val();
              }
              const $breadcrumbContainer = $('.breadcrumb__container');
              const $collectionMatrix = $('.collection-matrix');
              const $collectionMain = $('[data-collection-main]');

              // Get and set new breadcrumb html
              const filteredBreadcrumb = $(data).find('.breadcrumb__container').html();
              $breadcrumbContainer.html(filteredBreadcrumb);

              // Remove loading animation
              $collectionMatrix.removeClass('fadeIn animated loading-in-progress');

              // Check for products
              const filteredData = $(data).find('.collection-matrix__wrapper');
              // var collection_data_old = $(data).find('.collection-matrix__wrapper');
              // var collection_data_old = collection_data_old.find('.product-item-product-card').remove();
              // const filteredData_new = $(data).find('.collection-matrix__wrapper .product-item-product-card').remove();
              // const filteredData_new = collection_data_old;

              // console.log('arr indexes');
              // Object.keys(arr).forEach(key => {
              //     const value = arr[key];
              //     console.log(key, value);
              //     filteredData_new.find('.collection-matrix__wrapper').append(value);
              // });

              // console.log('filteredData_new:');
              // console.log(filteredData_new);
              const filteredPageLinks = $(data).find('.container--pagination');
              const noProducts = $(data).find('.container--no-products-in-collection');
              const sort_by_filter_html = $(data).find('div.current_sort_by').html();
              console.log('sort_by_filter_html');
              console.log(sort_by_filter_html);

              if (filteredData.length) {
                // Add products to container
                $collectionMain.empty();
                $collectionMain.append(filteredData);
              } else {
                // Display no product message
                $collectionMain.empty();
                $collectionMain.append(noProducts);
              }

              $collectionMain.append(filteredPageLinks);

              $('.collection__main .collection-matrix__wrapper .collection-matrix').find('.product-item-product-card').remove();
              console.log('arr indexes');
              Object.keys(arr).forEach(key => {
                  const value = arr[key];
                  console.log(key, value);
                  $('.collection__main .collection-matrix__wrapper .collection-matrix').append(value);
              });

              var custom_brand_name = $('.custom_brand_name').val();
              var brand_new_arrivals_links = $('.brand_new_arrivals_links').val();
              window.history && window.history.pushState && window.history.pushState("", "", filterURL);
              if(Shopify.theme_settings.enable_shopify_collection_badges == true) {
                Shopify.theme.productReviews();
              }

              // Initiate infinite scrolling on new products appended to collection grid
              if ($('[data-custom-pagination]').length) {
                Shopify.theme.infiniteScroll.update();
              }

            });
          }
        });
    }else{
      $.ajax({
        type: 'GET',
        url: filterURL,
        beforeSend: function() {
          $('.collection-matrix').addClass('fadeOut animated loading-in-progress');
          $('.collection-matrix__wrapper .collection__loading-icon').fadeIn();
        },
        success: function(data) {
        },
        error: function(x, t, m) {
          console.log(x);
          console.log(t);
          console.log(m);
          location.replace(location.protocol + '//' + location.host + filterURL);

        },
        dataType: "html"
      }).then(function(data){
        console.log('collections');
        console.log(data);
        if( $('#sort-by').val() == 'new-arrival-descending' ){
          var tags_for_new_arrival = $('.new_arrival_tags').val();
        }
        const $breadcrumbContainer = $('.breadcrumb__container');
        const $collectionMatrix = $('.collection-matrix');
        const $collectionMain = $('[data-collection-main]');

        // Get and set new breadcrumb html
        const filteredBreadcrumb = $(data).find('.breadcrumb__container').html();
        $breadcrumbContainer.html(filteredBreadcrumb);

        // Remove loading animation
        $collectionMatrix.removeClass('fadeIn animated loading-in-progress');

        // Check for products
        const filteredData = $(data).find('.collection-matrix__wrapper');
        const filteredPageLinks = $(data).find('.container--pagination');
        const noProducts = $(data).find('.container--no-products-in-collection');
        const sort_by_filter_html = $(data).find('div.current_sort_by').html();
        console.log('sort_by_filter_html');
        console.log(sort_by_filter_html);

        if (filteredData.length) {
          // Add products to container
          $collectionMain.empty();
          $collectionMain.append(filteredData);
        } else {
          // Display no product message
          $collectionMain.empty();
          $collectionMain.append(noProducts);
        }

        $collectionMain.append(filteredPageLinks);

        var custom_brand_name = $('.custom_brand_name').val();
        var brand_new_arrivals_links = $('.brand_new_arrivals_links').val();
        window.history && window.history.pushState && window.history.pushState("", "", filterURL);
        if(Shopify.theme_settings.enable_shopify_collection_badges == true) {
          Shopify.theme.productReviews();
        }

        // Initiate infinite scrolling on new products appended to collection grid
        if ($('[data-custom-pagination]').length) {
          Shopify.theme.infiniteScroll.update();
        }

      });
    }
  },
  multiTagFilter: {
    init: function ($el) {

      // Show filter and hide siblings
      this.showSelectedFilter($el);

      // Update url
      Shopify.theme.jsCollection.filterURL();

      var urlIndex;
      if (Shopify.routes.root_url.length > 1) {
        urlIndex = 3
      } else {
        urlIndex = 2
      }

      // Hide filters if types or vendors is in URL (can't be combined)
      if ($.url(urlIndex) === 'types' || $.url(urlIndex) === 'vendors') {
        $('.block__tag-filter').remove();
      }

    },
    showSelectedFilter: function ($el) {
      const $sidebarToggleBlock = $el.parents('.sidebar-toggle-active');
      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.addClass('is-active');
      $filterItem.siblings(':not(.is-active)').addClass('is-hidden');
      $filterItem.find('[data-clear-filter]').removeClass('is-hidden');

      // If sidebar toggle is enabled, show filter in sidebar content
      if ($sidebarToggleBlock.length) {
        let $toggleBtn = $sidebarToggleBlock.find('[data-sidebar-block__toggle="closed"]');

        Shopify.theme.jsSidebar.openSidebarBlock($toggleBtn);
      }

    },
    clearSelectedFilter: function ($el) {

      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.removeClass('is-active')
            .find('input').prop("checked", false);
      $filterItem.siblings()
            .removeClass('is-hidden');
      $filterItem.find('[data-clear-filter]')
            .addClass('is-hidden');

      //Update url
      Shopify.theme.jsCollection.filterURL();
    }
  },
  unload: function($section) {
    $('#tag_filter, #sort-by').off();
    $('[data-option-filter]').off();
    $('[data-reset-filters]').off();
    $('[data-clear-filter]').off();
    Shopify.theme.breadcrumbs.unload();
  }
}

/******/ })()
;